import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import { TextField, MenuItem  } from '@material-ui/core';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    }
}));

function InheritanceBequest(props) {

    const igonFlag = useSelector(state => state.igon.igonFlag);

//     const [inheritanceBequestValue, setInheritanceBequestValue] = useState(null);
//     const [inheritanceBequestHelperText, inheritanceBequestHelper] = useState('必須');
//
//     const [inheritanceBequestValidate, checkInheritanceBequest] = useState(false);
//     const handleInheritanceBequest = (event) => {
//         if(event.target.value){
//             checkInheritanceBequest(false);
//             inheritanceBequestHelper('必須');
//             setInheritanceBequestValue(event.target.value);
//         }else{
//             checkInheritanceBequest(true);
//             inheritanceBequestHelper('相続・遺贈は必ずご入力くさだい。');
//             setInheritanceBequestValue(null);
//         }
//     }

    const options = [
        {
            value: '相続'
        },
        {
            value: '遺贈'
        }
    ];

    const classes = useStyles();

    if(igonFlag){
        return(
            <TextField
                id={props.inheritanceBequestId}
                select
                name={props.inheritanceBequestName}
                label="相続・遺贈"
                style={{ margin: 8 }}
                className={classes.required}
                placeholder="相続・遺贈をご入力ください。"
                helperText={props.inheritanceBequestHelperText}
                fullWidth
                margin="normal"
                inputProps={{
                    required: true,
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={props.handleInheritanceBequest}
                error={props.inheritanceBequestValidate}
                value={props.inheritanceBequestValue}
            >
                {
                    options.map((row, index) => {
                        return (
                            <MenuItem key={index} value={row.value}>
                                {row.value}
                            </MenuItem>
                        );
                    })
                }
            </TextField>
        );
    }else{
        return(<></>);
    }
}

export default InheritanceBequest;
